const dict = {
    state: {
        // 经常需要读取的数据字典
        sex: [],
        messageType: [],
        priority: [],
        leaveType: [],
        cooperationDurationType:[],//时长
        copyrightCategory:[],//类型  版权分类
        copyrightAuthType:[],// 版权授权类型
        copyrightStatus:[],//是否授权
        mediaPlatform:[],//媒体平台
    },
    mutations: {
        // 设置值的改变方法
        setSex(state, list) {
            state.sex = list;
        },
        setMessageType(state, list) {
            state.messageType = list;
        },
        setPriority(state, list) {
            state.priority = list;
        },
        setLeaveType(state, list) {
            state.leaveType = list;
        },
        setCooperationDurationType(state, list) {
            state.cooperationDurationType = list;
        },
        setCopyrightCategory(state, list) {
            state.copyrightCategory = list;
        },
        setCopyrightAuthType(state, list) {
            state.copyrightAuthType = list;
        },
        setCopyrightStatus(state, list) {
            state.copyrightStatus = list;
        },
        setMediaPlatforms(state, list) {
            state.mediaPlatform = list;
        },
    }
};

export default dict;
